<template>
  <div class="col-md-12">
    <select
      v-model="per_page"
      class="form-control pull-right"
      style="width: 40%; margin-bottom: 20px;"
      @change="fetch"
    >
      <option value="20">
        Show 20
      </option>
      <option value="50">
        Show 50
      </option>
      <option value="100">
        Show 100
      </option>
    </select>
    <table :class="classes">
      <thead>
        <tr>
          <th
            v-for="(column,index) in the_columns"
            :key="index"
          >
            <template v-if="column !== link">
              {{ column }}
            </template>
          </th>
          <th v-if="show.length > 0">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row,j) in data"
          :key="j"
        >
          <td
            v-for="(i,index) in the_columns"
            :key="index"
          >
            <template v-if="columns[i] !== link">
              {{ row[columns[i]] }}
            </template>
          </td>
          <td v-if="show.length > 0">
            <router-link :to="{name: show, params: {id: row[link]}}">
              <i class="fa fa-eye" /> show
            </router-link>
          </td>
        </tr>
        <tr v-if="data.length < 1">
          <td :colspan="columns_count">
            <div class="alert alert-warning">
              No records found
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <ul class="pagination">
      <template v-if="total > (page * per_page)">
        <li v-if="page > 1">
          <a
            href="#"
            @click.prevent="changePage(page-1)"
          >Previous</a>
        </li>
        <li><a href="#">{{ page }}</a></li>
        <li v-if="page > pages_count">
          <a
            href="#"
            @click.prevent="changePage"
          >Next</a>
        </li>
        <li v-if="page < pages_count">
          <a
            href="#"
            @click.prevent="changePage('next')"
          >Next</a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {

  props: {
    url: {
      type: String,
      default() {
        return '';
      }
    },

    classes: {
      type: String,
      default() {
        return 'table table-striped table-hover table-responsive';
      }
    },

    columns: {
      type: Object,
      default() {
        return {};
      }
    },

    show: {
      type: String,
      default: ''
    },

    link: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      data: [],
      page: 1,
      per_page: 20,
      total: 0,
    }
  },

  computed: {
    the_columns() {
      return Object.keys(this.columns);
    },

    the_mappings() {
      return Object.values(this.columns);
    },

    columns_count() {
      return this.the_columns.length;
    },

    pages_count() {
      return Math.ceil(this.total / this.per_page);
    }
  },

  watch: {
    url() {
      this.fetch();
    }
  },
  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      let url;
      if (this.url.indexOf('?') < 0) {
        url = this.url + '?per_page=' + this.per_page + '&page=' + this.page;
      } else {
        url = this.url + '&per_page=' + this.per_page + '&page=' + this.page;
      }

      this.data = [];

      this.$axios.get(url).then(response => {
        response.data.data.forEach(set => {
          let mapped = [];

          this.the_mappings.forEach(column => {
            let nestings = column.split('.');

            if (nestings.length === 1) {
              mapped[column] = set[nestings[0]];
            }

            if (nestings.length === 2) {
              mapped[column] = set[nestings[0]][nestings[1]];
            }

            if (nestings.length === 3) {
              mapped[column] = set[nestings[0]][nestings[1]][nestings[2]];
            }

          });

          this.data.push(mapped);
        });
        this.page = response.data.page;
        this.per_page = response.data.per_page;
        this.total = response.data.total;
      });
    },

    changePage(direction) {
      if (direction === 'next') {
        this.page = parseInt(this.page) + 1;
      } else {
        this.page = parseInt(this.page) - 1;
      }

      this.fetch();
    }
  }
}
</script>

<style lang="scss">

</style>
